module.exports = __webpack_public_path__ + "assets/globe_primary.c2516bae.svg";